import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import './BlogCarousel.css';

function BlogCarousel() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedPosts = async () => {
      try {
        const response = await axios.get('/api/blog/featured', {
          params: { limit: 10 }
        });
        console.log('BlogCarousel: получены featured посты:', response.data);
        setPosts(response.data || []);
      } catch (error) {
        console.error('Error fetching featured blog posts:', error);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedPosts();
  }, []);

  useEffect(() => {
    if (posts.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % posts.length);
    }, 5000); // Переключение каждые 5 секунд

    return () => clearInterval(interval);
  }, [posts.length]);

  const handleReadArticle = () => {
    if (posts[currentIndex]) {
      navigate(`/blog/${posts[currentIndex].slug}`);
    }
  };

  if (loading) {
    return (
      <div className="blog-carousel-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (posts.length === 0) {
    return null; // Не показываем карусель, если нет статей
  }

  const currentPost = posts[currentIndex];

  return (
    <section className="blog-carousel-section">
      <div 
        className="blog-carousel-slide"
        style={{
          backgroundImage: currentPost.image_url ? `url(${currentPost.image_url})` : 'none'
        }}
      >
        <div className="blog-carousel-overlay"></div>
        
        {/* Welcome Badge */}
        <div className="blog-carousel-welcome">
          <Sparkles size={16} />
          <span>Добро пожаловать, {user?.username || 'Пользователь'}!</span>
        </div>
        
        <div className="blog-carousel-content">
          <h1 className="blog-carousel-title">{currentPost.title}</h1>
          {currentPost.subtitle && (
            <p className="blog-carousel-subtitle">{currentPost.subtitle}</p>
          )}
          <button 
            className="blog-carousel-button"
            onClick={handleReadArticle}
          >
            Прочитать статью
            <ArrowRight size={16} />
          </button>
        </div>

        {posts.length > 1 && (
          <div className="blog-carousel-dots">
            {posts.map((_, index) => (
              <button
                key={index}
                className={`blog-carousel-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Перейти к статье ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default BlogCarousel;
